import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Electionpage.css';
import { useDispatch, useSelector } from 'react-redux';
import { stateListFetchData } from '../../../redux/actions/stateListAction';
import { citiesListFetchData } from '../../../redux/actions/citiesListAction';
import { stateSummaryActionFetchData } from '../../../redux/actions/StateSummaryAction';
import { constituenciesFetchData } from '../../../redux/actions/constituencies';
import { EleResultsFetchData } from '../../../redux/actions/EleResultsAction';
import ElectionDetailpage from './ElectionDetailpage';
import { votesData } from './votesJson';

import EleLocalImage from '../../../assets/GujaratMapHD.png';

const normalize = (str) => (str || "").toLowerCase().replace(/&/g, "and").replace(/\s+/g, "").replace(/[^a-z0-9]/g, "");

const ElectionPage = () => {
    const navigate = useNavigate();
    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [selectedStateId, setSelectedStateId] = useState("");
    const [selectedCityId, setSelectedCityId] = useState("");
    const [selectedConstituencyId, setSelectedConstituencyId] = useState(null);
    const [hasProcessedInitialState, setHasProcessedInitialState] = useState(false);
    const detailSectionRef = useRef(null);

    const dispatch = useDispatch();

    const colors = [
        "#FF7043", "#66BB6A", "#42A5F5", "#AB47BC",
        "#FFA726", "#26C6DA", "#EC407A", "#9CCC65",
        "#5C6BC0", "#FFCA28"
    ];
    const location = useLocation();
    const yearFromPath = location.pathname.includes('2021') ? '2021' : '2026';
    const election_id = location.state?.election_id || (yearFromPath === '2021' ? 6 : 5);
    const { stateClicked } = location.state || {};
    console.log(stateClicked == "Gujarat", "stateClicked");
    console.log(stateClicked == "ActiveStates", "stateClicked");


    useEffect(() => {

        setTimeout(() => {

            const paths = document.querySelectorAll(".svg-map__location");

            paths.forEach((path) => {

                const bbox = path.getBBox();

                const x = bbox.x + bbox.width / 2;
                const y = bbox.y + bbox.height / 2;

                const name = path.getAttribute("name");

                const text = document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    "text"
                );

                text.setAttribute("x", x);
                text.setAttribute("y", y);
                text.setAttribute("text-anchor", "middle");
                text.setAttribute("font-size", "12");
                text.setAttribute("font-weight", "bold");
                text.setAttribute("fill", "#000");

                text.textContent = name;

                path.parentNode.appendChild(text);

            });

        }, 500);

    }, []);
    useEffect(() => {
        dispatch(stateListFetchData(election_id))
        dispatch(stateSummaryActionFetchData())
    }, [dispatch, election_id])

    const stateListRoot = useSelector((state) => state?.stateListReducer?.data) || {};
    const stateListData = stateListRoot?.data || (Array.isArray(stateListRoot) ? stateListRoot : []);
    const citiesListRoot = useSelector((state) => state?.citiesListReducer?.data) || {};
    const citiesListData = citiesListRoot?.data || [];
    const stateSummaryData = useSelector((state) => state?.stateSummaryReducer?.data) || [];
    const constituenciesReducer = useSelector((state) => state?.constituenciesReducer);
    const EleResultsReducer = useSelector((state) => state?.EleResultsReducer?.data);

    const stateListReducer = Array.isArray(stateListData) ? stateListData : [];
    const citiesListReducer = Array.isArray(citiesListData) ? citiesListData : [];
    const stateSummaryReducer = Array.isArray(stateSummaryData?.data) ? stateSummaryData.data : (Array.isArray(stateSummaryData) ? stateSummaryData : []);
    const actualSummaryArray = stateSummaryReducer;

    useEffect(() => {
        if (stateClicked && stateListReducer.length > 0 && !hasProcessedInitialState) {
            console.log("Attempting to match initial state:", stateClicked);
            const matchingState = stateListReducer.find(s => normalize(s.name) === normalize(stateClicked));

            if (matchingState) {
                const stateIdStr = matchingState.id.toString();
                console.log("Matched state:", matchingState.name, "ID:", stateIdStr);

                // Set state selection
                setSelectedState(matchingState.name);
                setSelectedStateId(stateIdStr);

                // Clear any existing selections
                setSelectedCity("");
                setSelectedCityId("");
                setSelectedConstituencyId(null);

                // Fetch nested data
                dispatch(citiesListFetchData(matchingState.id, election_id));

                // Mark as processed so we don't override manual user changes later
                setHasProcessedInitialState(true);

                // Scroll to details
                scrollToDetails();
            } else {
                console.warn("Could not find matching state for:", stateClicked, "in list:", stateListReducer.map(s => s.name));
            }
        }
    }, [stateClicked, stateListReducer, dispatch, election_id, hasProcessedInitialState]);

    const { 21: assetbaseUrl } = useSelector((state) => state?.SettingReducer?.data || {});

    // Find the election report matching current election_id to get active_states, fallback to first item if not found
    const currentElectionReport = stateSummaryReducer?.find(item => String(item.election_id) === String(election_id)) || stateSummaryReducer?.[0];
    const activeStatesFromApi = currentElectionReport?.elections?.find(e => String(e.id) === String(election_id))?.active_states
        || currentElectionReport?.elections?.[0]?.active_states
        || [];

    const constituenciesData = constituenciesReducer?.data?.data || [];
    const drillDownParties = constituenciesReducer?.data?.parties || [];

    const scrollToDetails = () => {
        setTimeout(() => {
            if (detailSectionRef.current) {
                const yOffset = -100; // Account for sticky header
                const y = detailSectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        }, 150);
    };

    const handleStateChange = (e) => {
        const stateId = e.target.value;
        const stateObj = stateListReducer.find((s) => s.id.toString() === stateId.toString());
        const stateName = stateObj ? stateObj.name : "";

        setSelectedState(stateName);
        setSelectedStateId(stateId);
        setSelectedCity("");
        setSelectedCityId("");
        setSelectedConstituencyId(null);

        if (stateId) {
            dispatch(citiesListFetchData(stateId, election_id));
            // dispatch(constituenciesFetchData(stateId, "", election_id)); // Fetch state-wide constituencies
        }
        scrollToDetails();
    };

    const handleCityChange = (e) => {
        const cityId = e.target.value;
        const cityObj = citiesListReducer?.find((c) => c.id.toString() === cityId.toString());
        const cityName = cityObj ? cityObj.name : "";

        setSelectedCity(cityName);
        setSelectedCityId(cityId);
        setSelectedConstituencyId(null);

        if (cityId) {
            dispatch(constituenciesFetchData(selectedStateId, cityId, election_id));
        }
        scrollToDetails();
    };

    const handleConstituencyClick = (id) => {
        setSelectedConstituencyId(id);
        dispatch(EleResultsFetchData(id));
    };

    let rightSideParties = [];
    let maxSeats = 543;

    if (selectedState) {
        rightSideParties = stateSummaryReducer && stateSummaryReducer?.filter(
            (s) => normalize(s.state_name) === normalize(selectedState)
        );
        if (rightSideParties.length > 0) {
            maxSeats = rightSideParties[0].total_seats || Math.max(...rightSideParties.map(p => p.total_seats || 0), 1);
        }
    } else {
        const partyMap = {};
        stateSummaryReducer && stateSummaryReducer?.forEach(item => {
            const shortName = item.party_short_name || item.party_name;
            if (shortName && !partyMap[shortName]) {
                partyMap[shortName] = {
                    party_name: item.party_name,
                    party_short_name: item.party_short_name,
                    color_code: item.color_code,
                    seats_won: 0,
                    seats_leading: 0,
                    total_seats: 543
                };
            }
            if (shortName) {
                partyMap[shortName].seats_won += (item.seats_won || 0);
                partyMap[shortName].seats_leading += (item.seats_leading || 0);
            }
        });
        rightSideParties = Object.values(partyMap);
        maxSeats = 543;
    }

    rightSideParties.sort((a, b) => ((b.seats_won || 0) + (b.seats_leading || 0)) - ((a.seats_won || 0) + (a.seats_leading || 0)));
    const majorityMark = Math.floor(maxSeats / 2) + 1;

    // -- Dynamic Data Binding Logic --
    let activeParties = [];
    if (selectedCityId) {
        // As per user request: Bind from citiesListReducer parties object
        activeParties = citiesListRoot?.parties || drillDownParties;
    } else if (selectedStateId) {
        // As per user request: Bind from stateListReducer parties object
        activeParties = stateListRoot?.parties || drillDownParties;
    } else {
        // Default: Bind from stateSummaryReducer
        activeParties = rightSideParties;
    }

    const flattenedCandidates = (drillDownParties || []).flatMap(party =>
        (party.breakdown || []).map(candidate => ({
            ...candidate,
            partyName: party.name,
            partyShortName: party.short_name,
            partyColorCode: party.color_code
        }))
    );
    const currentStateStats = votesData.find(v => normalize(v.state) === normalize(selectedState)) || (normalize(selectedState) === "gujarat" ? {
        state: "Gujarat",
        total_population: "6.3 કરોડ",
        assembly_seats: 182,
        area_sq_km: "1,96,024",
        districts: 33,
        voters: { total: "4.9 કરોડ", male: "2.5 કરોડ", female: "2.4 કરોડ", others: "1,200+" }
    } : null);

    const formatNumber = (num) => typeof num === 'string' ? num : num?.toLocaleString('en-IN');

    return (
        <div className="election-page-root">
            {/* Top Minimal Navigation */}
            <nav className="ep-navbar">
                <div className="ep-nav-left">
                    <div className="ep-logo-container">

                        <div className="ep-logo-text">
                            <h1 className="ep-logo-title">Sandesh</h1>
                            <p className="ep-logo-subtitle">Election {yearFromPath}</p>
                        </div>
                    </div>
                    <div className="ep-nav-divider"></div>
                    <div className="ep-filters-bar">
                        <span className="ep-filters-label">FILTER ELECTION DATA :</span>

                        <select className="ep-select ep-filter-select" value={String(selectedStateId)} onChange={handleStateChange}>
                            <option value="">All India</option>
                            {stateListReducer?.map((state) => (
                                <option key={state.id} value={String(state.id)}>{state.name}</option>
                            ))}
                        </select>

                        {selectedStateId && citiesListReducer && citiesListReducer.length > 0 && (
                            <select className="ep-select ep-filter-select" value={selectedCityId} onChange={handleCityChange}>
                                <option value="">All Cities</option>
                                {citiesListReducer.map((city) => (
                                    <option key={city.id} value={city.id}>{city.name}</option>
                                ))}
                            </select>
                        )}
                    </div>
                </div>

                <div className="ep-nav-right">
                    <div className="ep-live-status">
                        <span className="live-dot"></span>
                        <span className="ep-live-text">Live News</span>
                    </div>
                </div>
            </nav>
            {stateClicked === "Gujarat" ? (
                <div className="ep-state-cards-container">
                    <div className="ep-gujarat-map-box">
                        <img src={EleLocalImage} alt="Gujarat Map" className="ep-gujarat-map-img" />
                    </div>
                </div>
            ) : (
                <div className="ep-state-cards-container">
                    <div className="ep-state-cards-row">
                        {yearFromPath === "2026" && activeStatesFromApi?.map((state, idx) => (
                            <div key={idx} className={`ep-state-card typographic ${normalize(selectedState) === normalize(state.name) ? 'active' : ''}`} onClick={() => {
                                const stateObj = stateListReducer.find(s => normalize(s.name) === normalize(state.name));
                                if (stateObj) {
                                    handleStateChange({ target: { value: stateObj.id } });
                                } else {
                                    setSelectedState(state.name);
                                    setSelectedStateId("");
                                    setSelectedCity("");
                                    setSelectedCityId("");
                                    setSelectedConstituencyId(null);
                                }
                                scrollToDetails();
                            }}>
                                <div className="ep-state-card-image-box typographic-bg">
                                    <img
                                        src={state.image_path ? (assetbaseUrl?.value + state.image_path) : state.image}
                                        alt={state.name}
                                        className="ep-state-card-img"
                                    />
                                </div>
                                <div className="ep-state-card-content">
                                    <h3 className="ep-state-card-name typographic">{state.gujarati || state.name}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            <div className="ed-flex-center" ref={detailSectionRef}>
              

            </div>
            {currentStateStats && (
                <div>
                    <div className="ele-section-header">
                        <div className="ele-title-wrap">
                            <h1 className="ed-title heading-font">{selectedState}<span style={{ color: 'var(--sandesh-red)' }}> ચૂંટણી</span></h1>
                        </div>
                    </div>
                    <div className="ep-stats-wrapper">
                        <div className="ele-stats-grid">
                            <div className="ele-stat-card">
                                <div className="ele-stat-icon-wrapper">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line></svg>
                                </div>
                                <p className="ele-stat-label">વિસ્તાર</p>
                                <p className="ele-stat-value">
                                    {formatNumber(currentStateStats.area_sq_km)} <span className="ele-stat-unit">કિમી²</span>
                                </p>
                            </div>

                            <div className="ele-stat-card">
                                <div className="ele-stat-icon-wrapper">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                                </div>
                                <p className="ele-stat-label">વસ્તી</p>
                                <p className="ele-stat-value">{formatNumber(currentStateStats.total_population)}</p>
                            </div>

                            <div className="ele-stat-card">
                                <div className="ele-stat-icon-wrapper">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
                                </div>
                                <p className="ele-stat-label">જિલ્લાઓ</p>
                                <p className="ele-stat-value">{currentStateStats.districts}</p>
                            </div>

                            <div className="ele-stat-card">
                                <div className="ele-stat-icon-wrapper">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 20h20"></path><path d="M7 14V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v9"></path><path d="M9 20v-6h6v6"></path></svg>
                                </div>
                                <p className="ele-stat-label">બેઠકો</p>
                                <p className="ele-stat-value">{currentStateStats.assembly_seats}</p>
                            </div>

                            <div className="ele-stat-card">
                                <div className="ele-stat-icon-wrapper">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>
                                </div>
                                <p className="ele-stat-label">પુરુષ મતદારો</p>
                                <p className="ele-stat-value">{formatNumber(currentStateStats.voters?.male)}</p>
                            </div>

                            <div className="ele-stat-card">
                                <div className="ele-stat-icon-wrapper" style={{ color: '#ec4899', background: '#fdf2f8' }}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>
                                </div>
                                <p className="ele-stat-label">મહિલા મતદારો</p>
                                <p className="ele-stat-value">{formatNumber(currentStateStats.voters?.female)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
          
            <ElectionDetailpage
                selectedState={selectedState}
                stateIdProp={selectedStateId}
                cityIdProp={selectedCityId}
            />
        </div>


    );
};

export default ElectionPage;